module.exports = __webpack_public_path__ + "static/media/BusinessManagement.48aa3490.png";